import { render, staticRenderFns } from "./WhyCasesPage.vue?vue&type=template&id=fe2f0d04&scoped=true"
import script from "./WhyCasesPage.vue?vue&type=script&lang=js"
export * from "./WhyCasesPage.vue?vue&type=script&lang=js"
import style0 from "./WhyCasesPage.vue?vue&type=style&index=0&id=fe2f0d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2f0d04",
  null
  
)

export default component.exports